import React from 'react';

const OldOrder = () => {
	return (
		<div>
			<div className="create-order-container">
				<div className="order-basic-info-section">
					<div className="form-title pt-2 d-flex justify-content-between align-items-center">
						<h3 className="semibold-14">Order basic information*</h3>
						<div className="order-assigned-people pb-2">
							<div className="add-buyer">
								<div className="added-members px-0">
									<div id="AddNewMember" className="add-new-member ">
										<img src="/icons/add-member.svg" alt="add-member" />
									</div>
									<img
										src="/images/alave.png"
										alt=""
										data-toggle="tooltip"
										data-placement="top"
										title
										data-original-title="Sadat"
									/>
									<img
										src="/images/alave.png"
										alt=""
										data-toggle="tooltip"
										data-placement="top"
										title
										data-original-title="Mamun"
									/>
									<img
										src="/images/alave.png"
										alt=""
										data-toggle="tooltip"
										data-placement="top"
										title
										data-original-title="Zahinul Haque"
									/>
									<img
										src="/images/alave.png"
										alt=""
										data-toggle="tooltip"
										data-placement="top"
										title
										data-original-title="pm"
									/>
									<div className="more-people">
										<a href="#">+1</a>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="info-and-po d-flex justify-content-between">
						<div className="info-column bg-white">
							<div className="container px-0">
								<div className="row">
									<div className="col-md-12">
										<div className="form-group">
											<label htmlFor="oder-title">Order title</label>
											<input type="number" id="oder-title" />
										</div>
									</div>
									<div className="col-md-6">
										<div className="form-group">
											<label htmlFor="s-buyer">Select buyer</label>
											<select name="s-buyer" id="s-buyer">
												<option>Select</option>
												<option value>Fabric</option>
												<option value>Trims</option>
												<option value>Label</option>
											</select>
										</div>
									</div>
									<div className="col-md-6">
										<div className="form-group mb-0">
											<label htmlFor="po-receive">PO receive date</label>
											<input type="date" id="po-receive" />
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="po-column bg-white">
							<div className="uploded-po pt-2">
								<div className="single-po d-flex justify-content-between align-items-center">
									<div className="po-names">
										<img src="/images/file-pdf.svg" alt="pdf" />{' '}
										<a href="#" target="_blank" rel="noopener noreferrer">
											BMW PO/2021
										</a>
									</div>
									<div className="delete-btn">
										<img src="/icons/delete_gray.svg" alt="delete" />
									</div>
								</div>
								<div className="single-po d-flex justify-content-between align-items-center">
									<div className="po-names">
										<img src="/images/file-pdf.svg" alt="pdf" />{' '}
										<a href="#" target="_blank" rel="noopener noreferrer">
											BMW PO/2021
										</a>
									</div>
									<div className="delete-btn">
										<img src="/icons/delete_gray.svg" alt="delete" />
									</div>
								</div>
								<div className="single-po d-flex justify-content-between align-items-center">
									<div className="po-names">
										<img src="/images/file-pdf.svg" alt="pdf" />{' '}
										<a href="#" target="_blank" rel="noopener noreferrer">
											BMW PO/2021
										</a>
									</div>
									<div className="delete-btn">
										<img src="/icons/delete_gray.svg" alt="delete" />
									</div>
								</div>
								<div className="single-po d-flex justify-content-between align-items-center">
									<div className="po-names">
										<img src="/images/file-pdf.svg" alt="pdf" />{' '}
										<a href="#" target="_blank" rel="noopener noreferrer">
											BMW PO/2021
										</a>
									</div>
									<div className="delete-btn">
										<img src="/icons/delete_gray.svg" alt="delete" />
									</div>
								</div>
								<div className="single-po d-flex justify-content-between align-items-center">
									<div className="po-names">
										<img src="/images/file-pdf.svg" alt="pdf" />{' '}
										<a href="#" target="_blank" rel="noopener noreferrer">
											BMW PO/2021
										</a>
									</div>
									<div className="delete-btn">
										<img src="/icons/delete_gray.svg" alt="delete" />
									</div>
								</div>
								<div className="single-po d-flex justify-content-between align-items-center">
									<div className="po-names">
										<img src="/images/file-pdf.svg" alt="pdf" />{' '}
										<a href="#" target="_blank" rel="noopener noreferrer">
											BMW PO/2021
										</a>
									</div>
									<div className="delete-btn">
										<img src="/icons/delete_gray.svg" alt="delete" />
									</div>
								</div>
								<div className="single-po d-flex justify-content-between align-items-center">
									<div className="po-names">
										<img src="/images/file-pdf.svg" alt="pdf" />{' '}
										<a href="#" target="_blank" rel="noopener noreferrer">
											BMW PO/2021
										</a>
									</div>
									<div className="delete-btn">
										<img src="/icons/delete_gray.svg" alt="delete" />
									</div>
								</div>
								<p className="regular-14 gray_dark_02 text-center no-po">No PO uploaded</p>
							</div>
							<div className="upload-po text-center">
								<label htmlFor="po-upload" className="drag-upload">
									<img src="/icons/upload-sm.svg" alt="" /> <span>Upload PO</span>
								</label>
								<input
									type="file"
									className="file-upload d-none"
									name="po-upload"
									id="po-upload"
									accept
								/>
							</div>
						</div>
					</div>
				</div>
				<div className="designs-info-section">
					<h3 className="semibold-14">Designs info</h3>
					<div className="designs-row">
						{/* Designwise quantity table */}
						<div className="single-design d-flex bg-white">
							<div className="design-image">
								<img src="/images/design-card-image.png" alt="" />
							</div>
							<div className="design-details-info">
								<div className="design-title mt-3 d-flex justify-content-between">
									<h3 className="semibold-16 mb-3">Blue Huddie Long Sleeve</h3>
									<div className="buttons">
										<span className="regular-14 primary_bright_01 cursor-pointer">
											Update
										</span>
										<span className="regular-14 red ml-2 cursor-pointer">Cancel</span>
										<span className="regular-14 primary_bright_01 ml-2 cursor-pointer">
											Edit
										</span>
									</div>
								</div>
								{/* <div class="po-details">
                                    <div class="container px-0">
                                        <div class="row">
                                            <div class="col-md-6 pr-1">
                                                <div class="form-group mb-0">
                                                    <label for="design-no">Design No</label>
                                                    <input type="number" id="" value="125/ASK/21-24/125">
                                                </div>
                                            </div>
                                            <div class="col-md-6 pl-1">
                                                <div class="form-group mb-0">
                                                    <label for="po-no">PO No</label>
                                                    <input type="number" id="" value="PO/45/KM/2021">
                                                </div>
                                            </div>
                                            <div class="col-md-12 mt-1">
                                                <div class="form-group mb-0">
                                                    <label for="etd">ETD</label>
                                                    <input type="date" id="">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}
								<div className="po-details-view">
									<div className="po-info-colums-view">
										<ul>
											<li>125/ASK/21-24/125</li>
											<li>PO: PO/45/KM/2021</li>
											<li>ETD: 25-Aug-2021</li>
										</ul>
									</div>
									<div className="po-quantity-colums-view">
										<ul>
											<li>
												<span>210</span> units
											</li>
											<li>
												<span>4</span> colors
											</li>
											<li>
												<span>6</span> size
											</li>
										</ul>
										<div className="total-value">
											<span className="regular-14 gray_dark_02">Total:</span>
											<span className="semibold-14"> $25,320</span>
										</div>
									</div>
								</div>
							</div>
							<div className="design-quantity-table">
								<div className="design-info-dropdowns">
									<div className="dropdows-row d-flex justify-content-end mb-1">
										<div className="option">
											<div className="dropdown">
												<button
													className="btn btn-default dropdown-toggle gray_dark_02 regular-14"
													type="button"
													data-toggle="dropdown"
													aria-expanded="false"
												>
													Designwise
													<img src="/icons/down-arrow.png" alt="down" />
												</button>
												<ul className="dropdown-menu dropdown-menu-right shadow-4dp">
													<li className="px-4 pb-3 pt-3">
														<a href className="gray_dark_02">
															Colorwise
														</a>
													</li>
													<li className="px-4 pb-3 pt-3">
														<a href className="gray_dark_02">
															Sizewise
														</a>
													</li>
													<li className="px-4 pb-3">
														<a href className="gray_dark_02">
															Size &amp; colorwise
														</a>
													</li>
												</ul>
											</div>
										</div>
										<div className="option">
											<div className="dropdown">
												<button
													className="btn btn-default dropdown-toggle gray_dark_02 regular-14"
													type="button"
													data-toggle="dropdown"
													aria-expanded="false"
												>
													FOB
													<img src="/icons/down-arrow.png" alt="down" />
												</button>
												<ul className="dropdown-menu dropdown-menu-right shadow-4db">
													<li className="px-4 pb-3 pt-3">
														<a href className="gray_dark_02">
															CIF
														</a>
													</li>
												</ul>
											</div>
										</div>
									</div>
								</div>
								<div className="design-table">
									<div className="category-wise-table design-wise-table">
										<table className="table">
											<thead>
												<tr>
													<th>
														<span className="cursor-pointer">
															<img src="/icons/Add.svg" alt="add" />
														</span>
													</th>
													<th>
														<p className="semibold-14 col-heading">XS</p>
													</th>
													<th>
														<p className="semibold-14 col-heading">S</p>
													</th>
													<th>
														<p className="semibold-14 col-heading">M</p>
													</th>
													<th>
														<p className="semibold-14 col-heading">L</p>
													</th>
													<th>
														<p className="semibold-14 col-heading">XL</p>
													</th>
													<th>
														<p className="semibold-14 col-heading cursor-pointer">
															<img src="/icons/plus-20.svg" alt="plus" />
														</p>
													</th>
												</tr>
											</thead>
											<tbody>
												<tr>
													<td>
														<span
															className="color-icon"
															style={{ background: 'rgb(131, 255, 131)' }}
														/>
													</td>
													<td>
														<input type="number" placeholder="00" />
													</td>
													<td>
														<input type="number" placeholder="00" />
													</td>
													<td>
														<input type="number" placeholder="00" />
													</td>
													<td>
														<input type="number" placeholder="00" />
													</td>
													<td>
														<input type="number" placeholder="00" />
													</td>
													<td>
														<input type="number" placeholder="00" />
													</td>
												</tr>
												<tr>
													<td>
														<span
															className="color-icon"
															style={{ background: 'rgb(122, 219, 122)' }}
														/>
													</td>
													<td>
														<input type="number" placeholder="00" />
													</td>
													<td>
														<input type="number" placeholder="00" />
													</td>
													<td>
														<input type="number" placeholder="00" />
													</td>
													<td>
														<input type="number" placeholder="00" />
													</td>
													<td>
														<input type="number" placeholder="00" />
													</td>
													<td>
														<input type="number" placeholder="00" />
													</td>
												</tr>
												<tr>
													<td>
														<span
															className="color-icon"
															style={{ background: 'rgb(41, 84, 141)' }}
														/>
													</td>
													<td>
														<input type="number" placeholder="00" />
													</td>
													<td>
														<input type="number" placeholder="00" />
													</td>
													<td>
														<input type="number" placeholder="00" />
													</td>
													<td>
														<input type="number" placeholder="00" />
													</td>
													<td>
														<input type="number" placeholder="00" />
													</td>
													<td>
														<input type="number" placeholder="00" />
													</td>
												</tr>
											</tbody>
										</table>
										<div className="total-units text-right">
											<span className="regular-14 gray_dark_02">
												Unit price: <input type="number" placeholder="$00" />
											</span>
										</div>
									</div>
								</div>
							</div>
						</div>
						{/* Sizewise quantity table */}
						<div className="single-design d-flex bg-white">
							<div className="design-image">
								<img src="/images/design-card-image.png" alt="" />
							</div>
							<div className="design-details-info">
								<div className="design-title mt-3 d-flex justify-content-between">
									<h3 className="semibold-16 mb-3">Blue Huddie Long Sleeve</h3>
									<div className="buttons">
										<span className="regular-14 primary_bright_01 cursor-pointer">
											Update
										</span>
										<span className="regular-14 red ml-2 cursor-pointer">Cancel</span>
										<span className="regular-14 primary_bright_01 ml-2 cursor-pointer">
											Edit
										</span>
									</div>
								</div>
								{/* <div class="po-details">
                                    <div class="container px-0">
                                        <div class="row">
                                            <div class="col-md-6 pr-1">
                                                <div class="form-group mb-0">
                                                    <label for="design-no">Design No</label>
                                                    <input type="number" id="" value="125/ASK/21-24/125">
                                                </div>
                                            </div>
                                            <div class="col-md-6 pl-1">
                                                <div class="form-group mb-0">
                                                    <label for="po-no">PO No</label>
                                                    <input type="number" id="" value="PO/45/KM/2021">
                                                </div>
                                            </div>
                                            <div class="col-md-12 mt-1">
                                                <div class="form-group mb-0">
                                                    <label for="etd">ETD</label>
                                                    <input type="date" id="">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}
								<div className="po-details-view">
									<div className="po-info-colums-view">
										<ul>
											<li>125/ASK/21-24/125</li>
											<li>PO: PO/45/KM/2021</li>
											<li>ETD: 25-Aug-2021</li>
										</ul>
									</div>
									<div className="po-quantity-colums-view">
										<ul>
											<li>
												<span>210</span> units
											</li>
											<li>
												<span>4</span> colors
											</li>
											<li>
												<span>6</span> size
											</li>
										</ul>
										<div className="total-value">
											<span className="regular-14 gray_dark_02">Total:</span>
											<span className="semibold-14"> $25,320</span>
										</div>
									</div>
								</div>
							</div>
							<div className="design-quantity-table">
								<div className="design-info-dropdowns">
									<div className="dropdows-row d-flex justify-content-end mb-1">
										<div className="option">
											<div className="dropdown">
												<button
													className="btn btn-default dropdown-toggle gray_dark_02 regular-14"
													type="button"
													data-toggle="dropdown"
													aria-expanded="false"
												>
													Sizewise
													<img src="/icons/down-arrow.png" alt="down" />
												</button>
												<ul className="dropdown-menu dropdown-menu-right shadow-4dp">
													<li className="px-4 pb-3 pt-3">
														<a href className="gray_dark_02">
															Designwise
														</a>
													</li>
													<li className="px-4 pb-3 pt-3">
														<a href className="gray_dark_02">
															Colorwise
														</a>
													</li>
													<li className="px-4 pb-3">
														<a href className="gray_dark_02">
															Size &amp; colorwise
														</a>
													</li>
												</ul>
											</div>
										</div>
										<div className="option">
											<div className="dropdown">
												<button
													className="btn btn-default dropdown-toggle gray_dark_02 regular-14"
													type="button"
													data-toggle="dropdown"
													aria-expanded="false"
												>
													FOB
													<img src="/icons/down-arrow.png" alt="down" />
												</button>
												<ul className="dropdown-menu dropdown-menu-right shadow-4db">
													<li className="px-4 pb-3 pt-3">
														<a href className="gray_dark_02">
															CIF
														</a>
													</li>
												</ul>
											</div>
										</div>
									</div>
								</div>
								<div className="design-table">
									<div className="category-wise-table sizewise-wise-table">
										<table className="table">
											<thead>
												<tr>
													<th>
														<span className="cursor-pointer">
															<img src="/icons/Add.svg" alt="add" />
														</span>
													</th>
													<th>
														<p className="semibold-14 col-heading">XS</p>
													</th>
													<th>
														<p className="semibold-14 col-heading">S</p>
													</th>
													<th>
														<p className="semibold-14 col-heading">M</p>
													</th>
													<th>
														<p className="semibold-14 col-heading">L</p>
													</th>
													<th>
														<p className="semibold-14 col-heading">XL</p>
													</th>
													<th>
														<p className="semibold-14 col-heading cursor-pointer">
															<img src="/icons/plus-20.svg" alt="plus" />
														</p>
													</th>
												</tr>
											</thead>
											<tbody>
												<tr>
													<td>
														<span
															className="color-icon"
															style={{ background: 'rgb(131, 255, 131)' }}
														/>
													</td>
													<td>
														<input type="number" placeholder="00" />
													</td>
													<td>
														<input type="number" placeholder="00" />
													</td>
													<td>
														<input type="number" placeholder="00" />
													</td>
													<td>
														<input type="number" placeholder="00" />
													</td>
													<td>
														<input type="number" placeholder="00" />
													</td>
													<td>
														<input type="number" placeholder="00" />
													</td>
												</tr>
												<tr>
													<td>
														<span
															className="color-icon"
															style={{ background: 'rgb(122, 219, 122)' }}
														/>
													</td>
													<td>
														<input type="number" placeholder="00" />
													</td>
													<td>
														<input type="number" placeholder="00" />
													</td>
													<td>
														<input type="number" placeholder="00" />
													</td>
													<td>
														<input type="number" placeholder="00" />
													</td>
													<td>
														<input type="number" placeholder="00" />
													</td>
													<td>
														<input type="number" placeholder="00" />
													</td>
												</tr>
												<tr>
													<td>
														<span
															className="color-icon"
															style={{ background: 'rgb(41, 84, 141)' }}
														/>
													</td>
													<td>
														<input type="number" placeholder="00" />
													</td>
													<td>
														<input type="number" placeholder="00" />
													</td>
													<td>
														<input type="number" placeholder="00" />
													</td>
													<td>
														<input type="number" placeholder="00" />
													</td>
													<td>
														<input type="number" placeholder="00" />
													</td>
													<td>
														<input type="number" placeholder="00" />
													</td>
												</tr>
												<tr>
													<td />
													<td>
														<input type="number" placeholder="$00.00" />
													</td>
													<td>
														<input type="number" placeholder="$00.00" />
													</td>
													<td>
														<input type="number" placeholder="$00.00" />
													</td>
													<td>
														<input type="number" placeholder="$00.00" />
													</td>
													<td>
														<input type="number" placeholder="$00.00 " />
													</td>
													<td />
												</tr>
											</tbody>
										</table>
									</div>
								</div>
							</div>
						</div>
						{/* Color wise quantity table */}
						<div className="single-design d-flex bg-white">
							<div className="design-image">
								<img src="/images/design-card-image.png" alt="" />
							</div>
							<div className="design-details-info">
								<div className="design-title mt-3 d-flex justify-content-between">
									<h3 className="semibold-16 mb-3">Blue Huddie Long Sleeve</h3>
									<div className="buttons">
										<span className="regular-14 primary_bright_01 cursor-pointer">
											Update
										</span>
										<span className="regular-14 red ml-2 cursor-pointer">Cancel</span>
										<span className="regular-14 primary_bright_01 ml-2 cursor-pointer">
											Edit
										</span>
									</div>
								</div>
								{/* <div class="po-details">
                                    <div class="container px-0">
                                        <div class="row">
                                            <div class="col-md-6 pr-1">
                                                <div class="form-group mb-0">
                                                    <label for="design-no">Design No</label>
                                                    <input type="number" id="" value="125/ASK/21-24/125">
                                                </div>
                                            </div>
                                            <div class="col-md-6 pl-1">
                                                <div class="form-group mb-0">
                                                    <label for="po-no">PO No</label>
                                                    <input type="number" id="" value="PO/45/KM/2021">
                                                </div>
                                            </div>
                                            <div class="col-md-12 mt-1">
                                                <div class="form-group mb-0">
                                                    <label for="etd">ETD</label>
                                                    <input type="date" id="">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}
								<div className="po-details-view">
									<div className="po-info-colums-view">
										<ul>
											<li>125/ASK/21-24/125</li>
											<li>PO: PO/45/KM/2021</li>
											<li>ETD: 25-Aug-2021</li>
										</ul>
									</div>
									<div className="po-quantity-colums-view">
										<ul>
											<li>
												<span>210</span> units
											</li>
											<li>
												<span>4</span> colors
											</li>
											<li>
												<span>6</span> size
											</li>
										</ul>
										<div className="total-value">
											<span className="regular-14 gray_dark_02">Total:</span>
											<span className="semibold-14"> $25,320</span>
										</div>
									</div>
								</div>
							</div>
							<div className="design-quantity-table">
								<div className="design-info-dropdowns">
									<div className="dropdows-row d-flex justify-content-end mb-1">
										<div className="option">
											<div className="dropdown">
												<button
													className="btn btn-default dropdown-toggle gray_dark_02 regular-14"
													type="button"
													data-toggle="dropdown"
													aria-expanded="false"
												>
													Colorwise
													<img src="/icons/down-arrow.png" alt="down" />
												</button>
												<ul className="dropdown-menu dropdown-menu-right shadow-4dp">
													<li className="px-4 pb-3 pt-3">
														<a href className="gray_dark_02">
															Designwise
														</a>
													</li>
													<li className="px-4 pb-3 pt-3">
														<a href className="gray_dark_02">
															Sizewise{' '}
														</a>
													</li>
													<li className="px-4 pb-3">
														<a href className="gray_dark_02">
															Size &amp; colorwise
														</a>
													</li>
												</ul>
											</div>
										</div>
										<div className="option">
											<div className="dropdown">
												<button
													className="btn btn-default dropdown-toggle gray_dark_02 regular-14"
													type="button"
													data-toggle="dropdown"
													aria-expanded="false"
												>
													FOB
													<img src="/icons/down-arrow.png" alt="down" />
												</button>
												<ul className="dropdown-menu dropdown-menu-right shadow-4db">
													<li className="px-4 pb-3 pt-3">
														<a href className="gray_dark_02">
															CIF
														</a>
													</li>
												</ul>
											</div>
										</div>
									</div>
								</div>
								<div className="design-table">
									<div className="category-wise-table color-wise-table">
										<table className="table">
											<thead>
												<tr>
													<th>
														<span className="cursor-pointer">
															<img src="/icons/Add.svg" alt="add" />
														</span>
													</th>
													<th>
														<p className="semibold-14 col-heading">XS</p>
													</th>
													<th>
														<p className="semibold-14 col-heading">S</p>
													</th>
													<th>
														<p className="semibold-14 col-heading">M</p>
													</th>
													<th>
														<p className="semibold-14 col-heading">L</p>
													</th>
													<th>
														<p className="semibold-14 col-heading">XL</p>
													</th>
													<th>
														<p className="semibold-14 col-heading cursor-pointer">
															<img src="/icons/plus-20.svg" alt="plus" />
														</p>
													</th>
													<th>
														<p className="semibold-14 col-heading">$</p>
													</th>
												</tr>
											</thead>
											<tbody>
												<tr>
													<td>
														<span
															className="color-icon"
															style={{ background: 'rgb(131, 255, 131)' }}
														/>
													</td>
													<td>
														<input type="number" placeholder="00" />
													</td>
													<td>
														<input type="number" placeholder="00" />
													</td>
													<td>
														<input type="number" placeholder="00" />
													</td>
													<td>
														<input type="number" placeholder="00" />
													</td>
													<td>
														<input type="number" placeholder="00" />
													</td>
													<td>
														<input type="number" placeholder="00" />
													</td>
													<td>
														<input type="number" placeholder="$00" />
													</td>
												</tr>
												<tr>
													<td>
														<span
															className="color-icon"
															style={{ background: 'rgb(122, 219, 122)' }}
														/>
													</td>
													<td>
														<input type="number" placeholder="00" />
													</td>
													<td>
														<input type="number" placeholder="00" />
													</td>
													<td>
														<input type="number" placeholder="00" />
													</td>
													<td>
														<input type="number" placeholder="00" />
													</td>
													<td>
														<input type="number" placeholder="00" />
													</td>
													<td>
														<input type="number" placeholder="00" />
													</td>
													<td>
														<input type="number" placeholder="$00" />
													</td>
												</tr>
												<tr>
													<td>
														<span
															className="color-icon"
															style={{ background: 'rgb(41, 84, 141)' }}
														/>
													</td>
													<td>
														<input type="number" placeholder="00" />
													</td>
													<td>
														<input type="number" placeholder="00" />
													</td>
													<td>
														<input type="number" placeholder="00" />
													</td>
													<td>
														<input type="number" placeholder="00" />
													</td>
													<td>
														<input type="number" placeholder="00" />
													</td>
													<td>
														<input type="number" placeholder="00" />
													</td>
													<td>
														<input type="number" placeholder="$00" />
													</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
							</div>
						</div>
						{/* Size & color wise quantity table */}
						<div className="single-design d-flex bg-white">
							<div className="design-image">
								<img src="/images/design-card-image.png" alt="" />
							</div>
							<div className="design-details-info">
								<div className="design-title mt-3 d-flex justify-content-between">
									<h3 className="semibold-16 mb-3">Blue Huddie Long Sleeve</h3>
									<div className="buttons">
										<span className="regular-14 primary_bright_01 cursor-pointer">
											Update
										</span>
										<span className="regular-14 red ml-2 cursor-pointer">Cancel</span>
										<span className="regular-14 primary_bright_01 ml-2 cursor-pointer">
											Edit
										</span>
									</div>
								</div>
								{/* <div class="po-details">
                                    <div class="container px-0">
                                        <div class="row">
                                            <div class="col-md-6 pr-1">
                                                <div class="form-group mb-0">
                                                    <label for="design-no">Design No</label>
                                                    <input type="number" id="" value="125/ASK/21-24/125">
                                                </div>
                                            </div>
                                            <div class="col-md-6 pl-1">
                                                <div class="form-group mb-0">
                                                    <label for="po-no">PO No</label>
                                                    <input type="number" id="" value="PO/45/KM/2021">
                                                </div>
                                            </div>
                                            <div class="col-md-12 mt-1">
                                                <div class="form-group mb-0">
                                                    <label for="etd">ETD</label>
                                                    <input type="date" id="">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}
								<div className="po-details-view">
									<div className="po-info-colums-view">
										<ul>
											<li>125/ASK/21-24/125</li>
											<li>PO: PO/45/KM/2021</li>
											<li>ETD: 25-Aug-2021</li>
										</ul>
									</div>
									<div className="po-quantity-colums-view">
										<ul>
											<li>
												<span>210</span> units
											</li>
											<li>
												<span>4</span> colors
											</li>
											<li>
												<span>6</span> size
											</li>
										</ul>
										<div className="total-value">
											<span className="regular-14 gray_dark_02">Total:</span>
											<span className="semibold-14"> $25,320</span>
										</div>
									</div>
								</div>
							</div>
							<div className="design-quantity-table">
								<div className="design-info-dropdowns">
									<div className="dropdows-row d-flex justify-content-end mb-1">
										<div className="option">
											<div className="dropdown">
												<button
													className="btn btn-default dropdown-toggle gray_dark_02 regular-14"
													type="button"
													data-toggle="dropdown"
													aria-expanded="false"
												>
													Colorwise
													<img src="/icons/down-arrow.png" alt="down" />
												</button>
												<ul className="dropdown-menu dropdown-menu-right shadow-4dp">
													<li className="px-4 pb-3 pt-3">
														<a href className="gray_dark_02">
															Designwise
														</a>
													</li>
													<li className="px-4 pb-3 pt-3">
														<a href className="gray_dark_02">
															Sizewise{' '}
														</a>
													</li>
													<li className="px-4 pb-3">
														<a href className="gray_dark_02">
															Size &amp; colorwise
														</a>
													</li>
												</ul>
											</div>
										</div>
										<div className="option">
											<div className="dropdown">
												<button
													className="btn btn-default dropdown-toggle gray_dark_02 regular-14"
													type="button"
													data-toggle="dropdown"
													aria-expanded="false"
												>
													FOB
													<img src="/icons/down-arrow.png" alt="down" />
												</button>
												<ul className="dropdown-menu dropdown-menu-right shadow-4db">
													<li className="px-4 pb-3 pt-3">
														<a href className="gray_dark_02">
															CIF
														</a>
													</li>
												</ul>
											</div>
										</div>
									</div>
								</div>
								<div className="design-table">
									<div className="category-wise-table size-color-wise-table">
										<table className="table">
											<thead>
												<tr>
													<th>
														<span className="cursor-pointer">
															<img src="/icons/Add.svg" alt="add" />
														</span>
													</th>
													<th>
														<span className="d-flex">
															<p className="semibold-14 col-heading">XS</p>
															<p className="semibold-14 col-heading">$</p>
														</span>
													</th>
													<th>
														<span className="d-flex">
															<p className="semibold-14 col-heading">S</p>
															<p className="semibold-14 col-heading">$</p>
														</span>
													</th>
													<th>
														<span className="d-flex">
															<p className="semibold-14 col-heading">M</p>
															<p className="semibold-14 col-heading">$</p>
														</span>
													</th>
													<th>
														<span className="d-flex">
															<p className="semibold-14 col-heading">L</p>
															<p className="semibold-14 col-heading">$</p>
														</span>
													</th>
													<th>
														<span className="d-flex">
															<p className="semibold-14 col-heading">XL</p>
															<p className="semibold-14 col-heading">$</p>
														</span>
													</th>
													<th>
														<span className="d-flex">
															<p className="semibold-14 col-heading">XXL</p>
															<p className="semibold-14 col-heading">$</p>
														</span>
													</th>
													<th>
														<p className="semibold-14 col-heading cursor-pointer">
															<img src="/icons/plus-20.svg" alt="plus" />
														</p>
													</th>
												</tr>
											</thead>
											<tbody>
												<tr>
													<td>
														<span
															className="color-icon"
															style={{ background: 'rgb(212, 118, 10)' }}
														/>
													</td>
													<td>
														<span className="d-flex">
															<input type="number" placeholder="Qty" />
															<input type="number" placeholder="$/Unit" />
														</span>
													</td>
													<td>
														<span className="d-flex">
															<input type="number" placeholder="Qty" />
															<input type="number" placeholder="$/Unit" />
														</span>
													</td>
													<td>
														<span className="d-flex">
															<input type="number" placeholder="Qty" />
															<input type="number" placeholder="$/Unit" />
														</span>
													</td>
													<td>
														<span className="d-flex">
															<input type="number" placeholder="Qty" />
															<input type="number" placeholder="$/Unit" />
														</span>
													</td>
													<td>
														<span className="d-flex">
															<input type="number" placeholder="Qty" />
															<input type="number" placeholder="$/Unit" />
														</span>
													</td>
													<td>
														<span className="d-flex">
															<input type="number" placeholder="Qty" />
															<input type="number" placeholder="$/Unit" />
														</span>
													</td>
													<td>
														<input type="number" placeholder="00" />
													</td>
												</tr>
												<tr>
													<td>
														<span
															className="color-icon"
															style={{ background: 'rgb(212, 118, 10)' }}
														/>
													</td>
													<td>
														<span className="d-flex">
															<input type="number" placeholder="Qty" />
															<input type="number" placeholder="$/Unit" />
														</span>
													</td>
													<td>
														<span className="d-flex">
															<input type="number" placeholder="Qty" />
															<input type="number" placeholder="$/Unit" />
														</span>
													</td>
													<td>
														<span className="d-flex">
															<input type="number" placeholder="Qty" />
															<input type="number" placeholder="$/Unit" />
														</span>
													</td>
													<td>
														<span className="d-flex">
															<input type="number" placeholder="Qty" />
															<input type="number" placeholder="$/Unit" />
														</span>
													</td>
													<td>
														<span className="d-flex">
															<input type="number" placeholder="Qty" />
															<input type="number" placeholder="$/Unit" />
														</span>
													</td>
													<td>
														<span className="d-flex">
															<input type="number" placeholder="Qty" />
															<input type="number" placeholder="$/Unit" />
														</span>
													</td>
													<td>
														<input type="number" placeholder="00" />
													</td>
												</tr>
												<tr>
													<td>
														<span
															className="color-icon"
															style={{ background: 'rgb(212, 118, 10)' }}
														/>
													</td>
													<td>
														<span className="d-flex">
															<input type="number" placeholder="Qty" />
															<input type="number" placeholder="$/Unit" />
														</span>
													</td>
													<td>
														<span className="d-flex">
															<input type="number" placeholder="Qty" />
															<input type="number" placeholder="$/Unit" />
														</span>
													</td>
													<td>
														<span className="d-flex">
															<input type="number" placeholder="Qty" />
															<input type="number" placeholder="$/Unit" />
														</span>
													</td>
													<td>
														<span className="d-flex">
															<input type="number" placeholder="Qty" />
															<input type="number" placeholder="$/Unit" />
														</span>
													</td>
													<td>
														<span className="d-flex">
															<input type="number" placeholder="Qty" />
															<input type="number" placeholder="$/Unit" />
														</span>
													</td>
													<td>
														<span className="d-flex">
															<input type="number" placeholder="Qty" />
															<input type="number" placeholder="$/Unit" />
														</span>
													</td>
													<td>
														<input type="number" placeholder="00" />
													</td>
												</tr>
												<tr>
													<td>
														<span
															className="color-icon"
															style={{ background: 'rgb(212, 118, 10)' }}
														/>
													</td>
													<td>
														<span className="d-flex">
															<input type="number" placeholder="Qty" />
															<input type="number" placeholder="$/Unit" />
														</span>
													</td>
													<td>
														<span className="d-flex">
															<input type="number" placeholder="Qty" />
															<input type="number" placeholder="$/Unit" />
														</span>
													</td>
													<td>
														<span className="d-flex">
															<input type="number" placeholder="Qty" />
															<input type="number" placeholder="$/Unit" />
														</span>
													</td>
													<td>
														<span className="d-flex">
															<input type="number" placeholder="Qty" />
															<input type="number" placeholder="$/Unit" />
														</span>
													</td>
													<td>
														<span className="d-flex">
															<input type="number" placeholder="Qty" />
															<input type="number" placeholder="$/Unit" />
														</span>
													</td>
													<td>
														<span className="d-flex">
															<input type="number" placeholder="Qty" />
															<input type="number" placeholder="$/Unit" />
														</span>
													</td>
													<td>
														<input type="number" placeholder="00" />
													</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="submit-button text-right">
						<button className="button size32 ml-2">Submit</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default OldOrder;
